import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./stripeSuccessfulPage.module.css";
import {
   BillingReason,
   SUPPORT_EMAIL,
   SubscriptionStatus
} from "../../../components/Billing/billingCodes";
import { formatBillingDate } from "../../../components/Billing/billingDates";

// What the trial the sign up just started comes to: the subscription's billing
// status knows when it ends. A reload loses the state the sign up navigated
// here with, so every line reads as well without it.
const describeTrial = ({ billingStatus, trialDays }) => {
   const trialEnd = formatBillingDate(billingStatus?.trialEnd);

   if (trialEnd) return `It runs until ${trialEnd}.`;
   if (typeof trialDays === "number" && trialDays > 0) return `It runs for ${trialDays} days.`;
   return "";
};

function FreeTrialSuccessfulPage() {
   const { state } = useLocation();
   const navigate = useNavigate();
   const billingStatus = state?.billingStatus;
   // A packet with no trial days starts none, and with no card on file nothing
   // is subscribed yet (PAYMENT_METHOD_REQUIRED): signing in lands on the card
   // form that starts it.
   const startedTrial = billingStatus?.subscriptionStatus === SubscriptionStatus.TRIALING;
   // Enterprise asked for: nothing starts until our team's terms are taken up,
   // which the billing page offers on signing in (components/Billing/enterprise.js).
   const requestedEnterprise = billingStatus?.reason === BillingReason.ENTERPRISE_OFFER_PENDING;

   const handleClick = (event) => {
      event.preventDefault();
      navigate("/auth/login");
   };

   return (
      <div className={styles["stripe-success-container"]}>
         {/* On the new billing flow no card is asked for at sign up, and a trial
             that ends without one pauses rather than charging anything — so
             the page says when it ends, and where a card is added. */}
         {requestedEnterprise ? (
            <>
               <h1 className={styles["stripe-success-title"]}>Your Enterprise request is in!</h1>
               <br />
               <h4 className={styles["stripe-success-description"]}>
                  {state?.enterpriseMessageSent ? (
                     "We've sent your request to our team and emailed you a confirmation. They will contact you to agree the prices and limits of your plan."
                  ) : (
                     `Our team will contact you to agree the prices and limits of your plan. To tell us what you need, write to ${SUPPORT_EMAIL}.`
                  )}{" "}
                  Sign in any time: your billing page shows your plan as soon as it's ready, and you
                  can start on a standard plan instead.
               </h4>
            </>
         ) : billingStatus && !startedTrial ? (
            <>
               <h1 className={styles["stripe-success-title"]}>Your account is ready!</h1>
               <br />
               <h4 className={styles["stripe-success-description"]}>
                  Sign in to add your billing details and a card. Your plan starts, and its first
                  payment is taken, as soon as the card is saved.
               </h4>
            </>
         ) : (
            <>
               <h1 className={styles["stripe-success-title"]}>Your free trial has started!</h1>
               <br />
               <h4 className={styles["stripe-success-description"]}>
                  {describeTrial(state ?? {})} No card is needed until then. Add one from
                  Subscription settings whenever you're ready, and KAPsurvey carries on without a
                  break when the trial ends.
               </h4>
            </>
         )}
         <br />
         <button
            className={styles["stripe-success-button"]}
            onClick={(event) => handleClick(event)}
         >
            Sign in now
         </button>
      </div>
   );
}

export default FreeTrialSuccessfulPage;
